import selectedMixin from "./selectedMixin";

export default {
  mixins: [
    selectedMixin
  ],
  computed: {
    remainingColumns(): number {
      // 5 represents the minimum number of columns required in each table
      let remaining = 5 - this.selectedObjectModel.permissionPermitteesArray.length;
      return  remaining > 0 ? remaining : 0;
    } 
  }
}

